import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ChatGlobalSocketService {
  public messageSeenNumSubject: Subject<any> = new Subject<any>();

  public sendBoxMessagesSubject: Subject<any> = new Subject<any>();

  clear() {
    this.messageSeenNumSubject.complete();
    this.messageSeenNumSubject = new Subject<any>();

    this.sendBoxMessagesSubject.complete();
    this.sendBoxMessagesSubject = new Subject<any>();
  }
}
